import React, { useState, useEffect, useRef } from 'react';
import { createRoot } from 'react-dom/client';
import { FaFacebook, FaYoutube, FaInstagram, FaBars, FaTimes } from 'react-icons/fa';
import { SlArrowRight, SlArrowLeft } from 'react-icons/sl';
import { IoCloseCircleOutline } from 'react-icons/io5';
import emailjs from '@emailjs/browser';

// Dane zastępcze dla demonstracji i jako fallback gdy pliki JSON nie zostaną znalezione
const placeholderDescription = {
  title: "Funkcje programu",
  whatIsTitle: "Co to jest OILManager?",
  whatIsParagraph1: "W dzisiejszym dynamicznym środowisku przemysłowym, efektywne zarządzanie zasobami jest kluczem do sukcesu. W przypadku firm operujących maszynami i urządzeniami wymagającymi regularnej obsługi olejowej, program OIL Manager staje się niezastąpionym narzędziem, które optymalizuje procesy, minimalizuje ryzyko awarii i znacząco obniża koszty operacyjne. Moduł AI wspiera podejmowanie decyzji i sugeruje konkretne działania aby oszczędzać czas i koszty utrzymania maszyn oraz służb utrzymania ruchu.",
  whatIsParagraph2: "OILManager to zaawansowana aplikacja desktopowa, zaprojektowana z myślą o kompleksowym zarządzaniu gospodarką olejową w przedsiębiorstwach. Niezależnie od tego, czy Twoja firma posiada rozbudowany park maszynowy, czy mniejszą liczbę jednostek, program dostarcza wszystkie niezbędne funkcjonalności do monitorowania, planowania i raportowania działań związanych z olejami.",
  complianceTitle: "Zgodność z normami",
  complianceList: [
    "ISO 6743",
    "ISO 4406",
    "ISO 14224",
    "ISO 55000 / ISO 55001 / ISO 55002",
    "PN-EN 13306"
  ],
  keyFeaturesTitle: "Kluczowe funkcje",
  features: [
    {
      title: "Centralna baza danych jednostek",
      points: [
        "Przechowywanie szczegółowych informacji o każdej jednostce (maszynie, urządzeniu).",
        "Łatwy dostęp do pełnej historii każdej jednostki, w tym przeprowadzonych badań i serwisów."
      ]
    },
    {
      title: "Zarządzanie harmonogramem badań wewnętrznych i zewnętrznych",
      points: [
        "Automatyczne śledzenie dat pobrania próbek do badań.",
        "Generowanie harmonogramów kolejnych pobrań.",
        "Wizualizacja zbliżających się terminów, zapewniająca pełną kontrolę."
      ]
    },
    {
      title: "Zarządzanie zapasami środków smarnych",
      points: [
        "Pełna kontrola nad stanem magazynowym.",
        "Automatyczne powiadomienia o niskim poziomie zapasów.",
        "Generowanie zleceń zakupowych.",
        "Analiza kosztów zakupu i zużycia."
      ]
    },
    {
      title: "Raportowanie i analiza",
      points: [
        "Wykresy i wizualizacje zużycia oleju.",
        "Prognozowanie przyszłego zapotrzebowania.",
        "Eksport danych do Excel."
      ]
    },
    {
      title: "Optymalizacja kosztów",
      points: [
        "Analiza trendów danych z badań olejowych wewnętrznych jak i zewnętrznych.",
        "Powiadomienia o zbliżających się badaniach.",
        "Eksport danych do formatu Excel.",
        "Generowanie planu badań."
      ]
    },
    {
      title: "Wsparcie techniczne",
      points: [
        "Szkolenia online i stacjonarne.",
        "Baza wiedzy i instrukcje.",
        "Szybka reakcja na zgłoszenia."
      ]
    },
    {
      title: "Integracja",
      points: [
        "Możliwość integracji danych systemami ERP",
        "Bezpieczeństwo - dane na własnym serwerze.",
        "Wysyłanie powiadomień Email do zainteresowanych",
        "Eksporty raportów do Excel, Word."
      ]
    },
  ],
  benefitsTitle: "Korzyści z wdrożenia OILManager:",
  benefits: [
    {
      title: "Optymalizacja kosztów",
      description: "Precyzyjne zarządzanie zapasami olejów i planowanie badań pozwala unikać nadmiernych zakupów oraz niepotrzebnych wymian."
    },
    {
      title: "Predykcja",
      description: "Generowane statystyki wraz z trendem prawdopodobieństwa i określanie przyszłego stanu układu wraz ze wsparciem genratywnej sztucznej inteligencji przy podejmowaniu decyzji."
    },
    {
      title: "Zwiększona niezawodność",
      description: "Regularne monitorowanie stanu olejów i planowanie serwisów minimalizuje ryzyko awarii maszyn i wydłuża ich żywotność."
    },
    {
      title: "Łatwa obsługa",
      description: "Intuicyjny interfejs sprawia, że wdrożenie i codzienna praca z systemem jest prosta dla każdego pracownika."
    },
    {
      title: "Efektywność operacyjna",
      description: "Centralizacja danych i automatyzacja procesów oszczędza czas i zasoby, eliminując ręczne prowadzenie dokumentacji."
    },
    {
      title: "Zgodność z normami",
      description: "Ułatwia utrzymanie zgodności z wewnętrznymi procedurami i zewnętrznymi regulacjami dotyczącymi zarządzania smarowaniem."
    },
    {
      title: "Wsparcie w podejmowaniu decyzji",
      description: "Dostęp do kompleksowych raportów i analiz trendów umożliwia podejmowanie świadomych decyzji dotyczących gospodarki olejowej i smarowniczej."
    },
    {
      title: "Profesjonalne wsparcie",
      description: "Nasz zespół ekspertów jest do Twojej dyspozycji, aby pomóc w każdym wyzwaniu technicznym i operacyjnym."
    },
    {
      title: "Redukcja śladu węglowego",
      description: "Dzięki optymalizacji zużycia oleju i redukcji odpadów, przyczyniasz się do ochrony środowiska, poprawiając wizerunek swojej firmy."
    }
  ]
};

const placeholderOffer = {
  title: "Nasza oferta",
  subtitle: "Wybierz plan dopasowany do Twoich potrzeb. Niezależnie od wielkości firmy, mamy rozwiązanie, które pomoże Ci zoptymalizować procesy.",
  plans: [
    {
      title: "BASIC",
      description: "Idealny dla małych firm z prostą strukturą.",
      features: [
        "Dostęp dla 10 użytkowników",
        "Monitorowanie do 50 maszyn",
        "Podstawowe raportowanie",
        "Wsparcie online (e-mail)"
      ]
    },
    {
      title: "BUSINESS",
      description: "Dla średnich firm, które potrzebują pełnej kontroli.",
      features: [
        "Dostęp dla 50 użytkowników",
        "Monitorowanie do 500 maszyn",
        "Zaawansowane raporty i analizy",
        "Automatyzacja procesów",
        "Wsparcie telefoniczne i online"
      ]
    },
    {
      title: "ENTERPRISE",
      description: "Pełne, skalowalne rozwiązanie dla dużych korporacji.",
      features: [
        "Nielimitowana liczba użytkowników",
        "Nielimitowana liczba maszyn",
        "Integracja z systemami zewnętrznymi",
        "Dedykowany opiekun klienta",
        "Szkolenia na miejscu"
      ]
    },
    {
      title: "DEDYKOWANY",
      description: "Rozwiązanie skrojone na miarę, dokładnie pod Twoje potrzeby.",
      features: [
        "Indywidualny plan wdrożenia",
        "Rozwój funkcji na życzenie",
        "Wsparcie 24/7",
        "Możliwość integracji z nietypowymi systemami"
      ]
    }
  ]
};

// Adresy URL obrazów
const uploadedImageUrls = {
  logo: "/logo.jpg",
  layaout: "/layaout.jpg",
  kolo: "/kolo.jpg",
  logo5: "/logo5.jpg",
  programScreenshots: [
    "/1.jpg",
    "/2.jpg",
    "/3.jpg",
    "/4.jpg",
    "/5.jpg",
    "/6.jpg",
    "/7.jpg",
    "/8.jpg",
    "/9.jpg",
    "/10.jpg",
    "/11.jpg",
    "/12.jpg",
    "/13.jpg",
    "/okno1.jpg",
    "/okno2.jpg",
    "/okno3.jpg",
    "/okno4.jpg",
    "/okno5.jpg",
  ]
};

// Funkcja pomocnicza do płynnego przewijania
const scrollToSection = (id) => {
  const element = document.getElementById(id);
  if (element) {
    element.scrollIntoView({ behavior: 'smooth' });
  }
};

// Komponent nagłówka
const Header = ({ onMenuToggle }) => (
  <header style={{ backgroundColor: 'rgb(242, 242, 242)' }} className="fixed top-0 left-0 right-0 z-50 p-4 md:p-6 text-black shadow-xl">
    <div className="container mx-auto flex justify-between items-center">
      <div className="flex items-center">
        <img
          src={uploadedImageUrls.logo}
          alt="Logo"
          className="h-12 w-auto"
        />
      </div>
      <nav className="hidden md:flex space-x-8">
        <button onClick={() => scrollToSection('description')} className="text-black hover:text-amber-400 transition-colors duration-300 font-medium">Opis</button>
        <button onClick={() => scrollToSection('offer')} className="text-black hover:text-amber-400 transition-colors duration-300 font-medium">Oferta</button>
        <button onClick={() => scrollToSection('contact')} className="text-black hover:text-amber-400 transition-colors duration-300 font-medium">Kontakt</button>
      </nav>
      <button onClick={onMenuToggle} className="md:hidden text-2xl focus:outline-none">
        <FaBars className="w-6 h-6" />
      </button>
    </div>
  </header>
);

// Komponent menu mobilnego
const MobileMenu = ({ isOpen, onClose }) => (
  <div className={`fixed inset-0 z-50 bg-[rgba(242,242,242,0.9)] backdrop-blur-sm transform ${isOpen ? 'translate-x-0' : 'translate-x-full'} transition-transform duration-300 ease-in-out md:hidden`}>
    <div className="flex justify-end p-4">
      <button onClick={onClose} className="text-black text-3xl">
        <FaTimes className="w-8 h-8" />
      </button>
    </div>
    <nav className="flex flex-col items-center justify-center h-full space-y-8 text-black text-2xl font-light">
      <button onClick={() => { scrollToSection('description'); onClose(); }} className="text-black hover:text-amber-400 transition-colors duration-300">Opis</button>
      <button onClick={() => { scrollToSection('offer'); onClose(); }} className="text-black hover:text-amber-400 transition-colors duration-300">Oferta</button>
      <button onClick={() => { scrollToSection('contact'); onClose(); }} className="text-black hover:text-amber-400 transition-colors duration-300">Kontakt</button>
    </nav>
  </div>
);

// Komponent sekcji Hero
const HeroSection = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const heroImages = [
    "/1.jpg",
    "/2.jpg",
    "/3.jpg",
    "/4.jpg",
    "/5.jpg",
    "/6.jpg",
    "/7.jpg",
    "/8.jpg",
    "/9.jpg",
    "/10.jpg",
    "/11.jpg",
    "/12.jpg",
    "/13.jpg",
    "/okno1.jpg",
    "/okno2.jpg",
    "/okno3.jpg",
    "/okno4.jpg",
    "/okno5.jpg"
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % heroImages.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [heroImages.length]);

  return (
    <section id="hero" className="relative w-full h-screen">
      <div className="absolute inset-0 w-full h-full">
        {heroImages.map((image, index) => (
          <img
            key={index}
            src={image}
            alt={`Tło programu ${index + 1}`}
            className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-1000 ease-in-out ${index === currentImageIndex ? 'opacity-100' : 'opacity-0'}`}
          />
        ))}
      </div>
      <div className="relative w-full h-full flex items-center justify-center p-4 text-center bg-black/50">
        <div className="max-w-4xl text-white">
          <p className="text-3xl font-extrabold text-amber-400 mb-2 animate-fadeInUp">OILManager</p>
          <h2 className="text-5xl md:text-6xl font-extrabold mb-4 animate-fadeInUp delay-200">
            Kompleksowe Zarządzanie Gospodarką Olejową
          </h2>
          <div className="relative w-full h-1 bg-amber-400 rounded-full my-4"></div>
          <p className="text-lg md:text-xl font-light mb-8 animate-fadeInUp delay-300">
            Zoptymalizuj procesy, zminimalizuj ryzyko awarii i znacząco obniż koszty operacyjne w Twojej firmie.
          </p>
          <button
            onClick={() => scrollToSection('offer')}
            className="bg-amber-400 text-black px-8 py-3 rounded-full font-bold text-lg hover:bg-amber-500 transition-transform duration-300 transform hover:scale-105 shadow-lg animate-fadeInUp delay-400"
          >
            Sprawdź naszą ofertę
          </button>
        </div>
      </div>
    </section>
  );
};

// Komponent modalu do wyświetlania zdjęć
const ImageModal = ({ isOpen, imageUrl, onClose }) => {
  const [scale, setScale] = useState(1);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);
  const [dragStart, setDragStart] = useState({ x: 0, y: 0 });

  const imageRef = useRef(null);
  const containerRef = useRef(null);

  useEffect(() => {
    setScale(1);
    setPosition({ x: 0, y: 0 });
  }, [imageUrl, isOpen]);

  if (!isOpen) return null;

  const handleBackgroundClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleMouseDown = (e) => {
    if (scale > 1) {
      setIsDragging(true);
      setDragStart({
        x: e.clientX - position.x,
        y: e.clientY - position.y
      });
    }
  };

  const handleMouseMove = (e) => {
    if (isDragging && scale > 1) {
      setPosition({
        x: e.clientX - dragStart.x,
        y: e.clientY - dragStart.y
      });
    }
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const handleWheel = (e) => {
    e.preventDefault();
    const delta = e.deltaY > 0 ? 0.9 : 1.1;
    setScale(prevScale => Math.min(Math.max(prevScale * delta, 1), 5));
  };

  const handleDoubleClick = () => {
    if (scale === 1) {
      setScale(2);
    } else {
      setScale(1);
    }
  };

  return (
    <div
      className="fixed inset-0 z-[100] bg-black/80 flex items-center justify-center p-4"
      onClick={handleBackgroundClick}
      onMouseUp={handleMouseUp}
      onMouseLeave={handleMouseUp}
    >
      <div
        ref={containerRef}
        className="relative w-auto max-w-[90vw] h-auto max-h-[90vh] bg-white rounded-lg overflow-hidden"
        onMouseMove={handleMouseMove}
        onWheel={handleWheel}
        onDoubleClick={handleDoubleClick}
      >
        <button
          onClick={onClose}
          className="absolute top-2 right-2 z-10 bg-black/50 text-white p-2 rounded-full hover:bg-black/80 transition-colors"
        >
          <FaTimes className="w-6 h-6" />
        </button>
        <div
          className="w-full h-full flex items-center justify-center overflow-hidden"
          onMouseDown={handleMouseDown}
        >
          <div
            style={{
              transform: `scale(${scale}) translate(${position.x / scale}px, ${position.y / scale}px)`,
              cursor: scale > 1 ? 'grab' : 'auto',
              transition: isDragging ? 'none' : 'transform 0.2s ease-out'
            }}
            className="relative"
          >
            <img
              ref={imageRef}
              src={imageUrl}
              alt="Powiększony widok"
              className="max-w-full max-h-full object-contain"
              draggable="false"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

// Sekcja opisu
const DescriptionSection = ({ descriptionData }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [imageAspectRatio, setImageAspectRatio] = useState(16 / 9);

  const screenshots = uploadedImageUrls.programScreenshots;

  const nextImage = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex + 1) % screenshots.length);
  };

  const prevImage = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex - 1 + screenshots.length) % screenshots.length);
  };

  const openImageModal = () => {
    setIsModalOpen(true);
  };

  const closeImageModal = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    const img = new Image();
    img.src = screenshots[currentImageIndex];
    img.onload = () => {
      if (img.naturalHeight > 0) {
        setImageAspectRatio(img.naturalWidth / img.naturalHeight);
      }
    };
  }, [currentImageIndex, screenshots]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (!isModalOpen) {
        nextImage();
      }
    }, 5000);
    return () => clearInterval(interval);
  }, [isModalOpen, currentImageIndex]);

  if (!descriptionData) {
    return (
      <section id="description" className="bg-gray-100 py-20 md:py-32 flex justify-center items-center">
        <div className="text-center text-xl text-gray-700">Ładowanie opisu...</div>
      </section>
    );
  }

  return (
    <section id="description" className="bg-gray-100 py-20 md:py-32">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="inline-block text-4xl md:text-5xl font-extrabold text-gray-900 mb-4 animate-slideInFromTop">
            {descriptionData.title.replace(/^OIL Manager:?\s*/, '')}
          </h2>
          <div className="mx-auto w-full max-w-max border-b-4 border-amber-400 mb-12"></div>
        </div>
        <div className="lg:flex lg:space-x-12 mb-16">
          <div className="lg:w-1/2 mb-8 lg:mb-0 space-y-6">
            <h3 className="text-3xl font-bold mb-6 text-gray-800">{descriptionData.whatIsTitle}</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
              <p className="text-lg text-gray-700 leading-relaxed">{descriptionData.whatIsParagraph1}</p>
              <p className="text-lg text-gray-700 leading-relaxed">{descriptionData.whatIsParagraph2}</p>
            </div>
            <div className="bg-gray-200 p-6 rounded-xl shadow-inner">
              <h4 className="text-xl font-semibold text-gray-800 mb-3">{descriptionData.complianceTitle}</h4>
              <ul className="grid grid-cols-2 gap-2 text-gray-600">
                {descriptionData.complianceList.map((item, index) => (
                  <li key={index} className="flex items-center">
                    <span className="text-amber-500 mr-2">•</span> {item}
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="lg:w-1/2 flex items-center justify-center">
            <div
              className="relative w-full rounded-xl overflow-hidden shadow-2xl cursor-pointer bg-gray-200 transition-all duration-500 ease-in-out"
              style={{ aspectRatio: `${imageAspectRatio}` }}
              onClick={openImageModal}
            >
              {screenshots.map((src, index) => (
                <img
                  key={index}
                  src={src}
                  alt={`Zrzut ekranu programu ${index + 1}`}
                  className={`absolute inset-0 w-full h-full object-contain transition-opacity duration-1000 ease-in-out ${
                    index === currentImageIndex ? 'opacity-100' : 'opacity-0'
                  }`}
                />
              ))}
              <div className="absolute inset-0 bg-black/10 opacity-0 hover:opacity-100 transition-opacity flex items-center justify-center">
                <span className="bg-black/60 text-white px-4 py-2 rounded-full text-sm">Kliknij, aby powiększyć</span>
              </div>
              <button
                onClick={(e) => { e.stopPropagation(); prevImage(); }}
                className="absolute left-4 top-1/2 transform -translate-y-1/2 p-2 rounded-full bg-black/30 text-white hover:bg-black/50 transition-colors z-10"
              >
                <SlArrowLeft className="w-6 h-6" />
              </button>
              <button
                onClick={(e) => { e.stopPropagation(); nextImage(); }}
                className="absolute right-4 top-1/2 transform -translate-y-1/2 p-2 rounded-full bg-black/30 text-white hover:bg-black/50 transition-colors z-10"
              >
                <SlArrowRight className="w-6 h-6" />
              </button>
            </div>
          </div>
        </div>

        <div className="mt-16">
          <h3 className="text-3xl font-bold text-gray-800 text-center mb-8">Kluczowe funkcje</h3>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {descriptionData.features.map((feature, index) => (
              <div key={index} className="bg-white p-8 rounded-xl shadow-xl border border-gray-200 animate-fadeInUp" style={{ animationDelay: `${index * 0.1}s` }}>
                <h4 className="text-2xl font-semibold text-amber-500 mb-3">{feature.title}</h4>
                <ul className="list-disc list-inside space-y-2 text-gray-700">
                  {feature.points.map((point, pointIndex) => (
                    <li key={pointIndex}>{point}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-20">
          <h3 className="text-3xl font-bold text-gray-800 text-center mb-8">Korzyści z wdrożenia OILManager:</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 text-center">
            {descriptionData.benefits.map((benefit, index) => (
              <div key={index} className="bg-white p-6 rounded-xl shadow-xl border-t-4 border-amber-500 animate-fadeInUp" style={{ animationDelay: `${index * 0.1}s` }}>
                <h4 className="text-xl font-semibold text-gray-900 mb-3">{benefit.title}</h4>
                <p className="text-gray-600">{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>

        <ImageModal
          isOpen={isModalOpen}
          imageUrl={screenshots[currentImageIndex]}
          onClose={closeImageModal}
        />
      </div>
    </section>
  );
};

// Sekcja oferty
const OfferSection = ({ offerData, onContactClick }) => {
  if (!offerData) {
    return (
      <section id="offer" className="bg-gray-900 py-20 md:py-32 text-white flex justify-center items-center">
        <div className="text-center text-xl text-gray-300">Ładowanie oferty...</div>
      </section>
    );
  }

  return (
    <section id="offer" className="bg-gray-900 py-20 md:py-32 text-white">
      <div className="container mx-auto px-4 text-center">
        <h2 className="inline-block text-4xl md:text-5xl font-extrabold mb-2 animate-slideInFromTop">{offerData.title}</h2>
        <div className="mx-auto w-full max-w-max border-b-4 border-amber-400 mb-8"></div>
        <p className="text-lg text-gray-300 mt-4 mb-16 max-w-2xl mx-auto animate-fadeInUp delay-100">{offerData.subtitle}</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 justify-items-center">
          {offerData.plans.map((plan, index) => (
            <div key={index} className="flex flex-col justify-between p-8 rounded-xl shadow-2xl border border-gray-700 hover:border-amber-400 transition-transform duration-300 transform hover:scale-105 animate-zoomIn w-full h-full max-w-sm" style={{ animationDelay: `${index * 0.1}s` }}>
              <div>
                <h3 className="text-3xl font-bold text-amber-400 mb-2">{plan.title}</h3>
                <p className="text-lg text-gray-300 mb-6">{plan.description}</p>
                <ul className="text-left text-gray-400 mb-8 space-y-2">
                  {plan.features.map((feature, featureIndex) => (
                    <li key={featureIndex}><span className="text-amber-400 mr-2">•</span> {feature}</li>
                  ))}
                </ul>
              </div>
              <button onClick={onContactClick} className="bg-amber-400 text-gray-900 px-6 py-2 rounded-full font-semibold hover:bg-amber-500 transition-colors mt-auto">Zapytaj o szczegóły</button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// Konfiguracja EmailJS
const EMAILJS_CONFIG = {
  SERVICE_ID: 'zapytania_oilmanager',
  TEMPLATE_ID: 'zapytanie_oilmanager',
  PUBLIC_KEY: 'YbNS-4-03-MOljtTR',
  DEFAULT_FROM: 'zapytania.oilmanager@gmail.com',
  TEST_MODE: false
};

// Inicjalizacja EmailJS
emailjs.init(EMAILJS_CONFIG.PUBLIC_KEY);

// Komponent modalu kontaktowego
const ContactModal = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    email: '',
    phone: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({ ...prevState, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.email || !formData.message) {
      setSubmitMessage('Proszę wypełnić wymagane pola (email i wiadomość).');
      return;
    }

    setIsSubmitting(true);
    setSubmitMessage('Wysyłanie...');

    try {
      const templateParams = {
        name: formData.email,
        email: formData.email,
        time: new Date().toLocaleString('pl-PL'),
        phone: formData.phone || 'Brak',
        message: formData.message,
        from_email: EMAILJS_CONFIG.DEFAULT_FROM,
        reply_to: formData.email
      };

      const response = await emailjs.send(
        EMAILJS_CONFIG.SERVICE_ID,
        EMAILJS_CONFIG.TEMPLATE_ID,
        templateParams
      );

      console.log('SUKCES! Status:', response.status, 'Text:', response.text);
      setSubmitMessage('Wiadomość została wysłana pomyślnie!');
      setFormData({ email: '', phone: '', message: '' });
    } catch (error) {
      console.error('BŁĄD:', error);
      let errorMsg = 'Wystąpił błąd podczas wysyłania wiadomości.';

      if (error.text) {
        if (error.text.includes('550')) {
          errorMsg = 'Błąd serwera SMTP: nieprawidłowy adres nadawcy.';
        } else if (error.text.includes('535')) {
          errorMsg = 'Błąd uwierzytelnienia SMTP. Sprawdź dane logowania.';
        } else if (error.text.includes('403')) {
          errorMsg = 'Dostęp zabroniony. Skontaktuj się z administratorem.';
        } else {
          try {
            const errorData = JSON.parse(error.text);
            errorMsg = errorData.message || errorMsg;
          } catch (e) {
            errorMsg = error.text || errorMsg;
          }
        }
      }

      setSubmitMessage(errorMsg);
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] bg-black/50 backdrop-blur-sm flex items-center justify-center p-4">
      <div className="bg-[rgb(242,242,242)] p-8 rounded-xl shadow-2xl w-full max-w-md relative">
        <button onClick={onClose} className="absolute top-4 right-4 text-3xl text-gray-500 hover:text-gray-800 transition-colors">
          <IoCloseCircleOutline className="w-8 h-8" />
        </button>
        <div className="flex justify-center mb-4">
          <img src={uploadedImageUrls.kolo} alt="Mini Logo" className="h-20 w-auto rounded-full" />
        </div>
        <h3 className="text-3xl font-bold text-gray-800 text-center mb-6">Formularz Kontaktowy</h3>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="email" className="block text-sm font-medium text-gray-700">Adres e-mail*</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder="Twój adres email"
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm p-3 focus:border-amber-500 focus:ring focus:ring-amber-200 focus:ring-opacity-50"
            />
          </div>
          <div>
            <label htmlFor="phone" className="block text-sm font-medium text-gray-700">Numer kontaktowy</label>
            <input
              type="tel"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              placeholder="Numer telefonu (opcjonalnie)"
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm p-3 focus:border-amber-500 focus:ring focus:ring-amber-200 focus:ring-opacity-50"
            />
          </div>
          <div>
            <label htmlFor="message" className="block text-sm font-medium text-gray-700">Treść wiadomości*</label>
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              rows="4"
              required
              placeholder="Treść wiadomości"
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm p-3 focus:border-amber-500 focus:ring focus:ring-amber-200 focus:ring-opacity-50"
            ></textarea>
          </div>
          <button
            type="submit"
            disabled={isSubmitting}
            className={`w-full py-3 rounded-md font-bold text-lg transition-colors ${
              isSubmitting
                ? 'bg-gray-400 cursor-not-allowed'
                : 'bg-amber-500 hover:bg-amber-600 text-white'
            }`}
          >
            {isSubmitting ? 'Wysyłanie...' : 'Wyślij wiadomość'}
          </button>
        </form>
        {submitMessage && (
          <p className={`mt-4 text-center text-sm font-medium ${
            submitMessage.includes('pomyślnie') || submitMessage.includes('sukces') ? 'text-green-600' : 'text-red-600'
          }`}>
            {submitMessage}
          </p>
        )}
      </div>
    </div>
  );
};

// Komponent stopki
const Footer = ({ onContactClick }) => (
  <footer id="contact" className="bg-gradient-to-r from-gray-900 to-black text-white py-12">
    <div className="container mx-auto px-4 text-center">
      <div className="flex flex-col md:flex-row items-center justify-between mb-8">
        <div className="flex items-center space-x-4 mb-4 md:mb-0">
          <a href="http://ckiki.pl" target="_blank" rel="noopener noreferrer">
            <img src={uploadedImageUrls.logo5} alt="Logo 5" className="h-16 w-auto rounded-full bg-gray-900" />
          </a>
          <a href="http://ckiki.pl" target="_blank" rel="noopener noreferrer" className="text-xl md:text-2xl font-bold font-inter hover:underline">
            Skontaktuj się z nami
          </a>
        </div>
        <div className="space-y-2 md:space-y-0 md:space-x-8">
          <div className="flex items-center justify-center md:justify-start">
            <span className="text-lg font-medium mr-2">Email:</span>
            <button onClick={onContactClick} className="text-amber-400 hover:underline">biuro@ckiki.pl</button>
          </div>
          <div className="flex space-x-4 justify-center md:justify-start mt-4 md:mt-0">
            <a href="https://www.facebook.com/profile.php?id=61579907707306" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <FaFacebook className="w-8 h-8 text-white hover:text-amber-400 transition-colors" />
            </a>
            <a href="https://www.youtube.com/@OILManager-cmms" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
              <FaYoutube className="w-8 h-8 text-white hover:text-amber-400 transition-colors" />
            </a>
            <a href="https://www.instagram.com/oilmanager.pl/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <FaInstagram className="w-8 h-8 text-white hover:text-amber-400 transition-colors" />
            </a>
          </div>
        </div>
      </div>
      <p className="text-sm text-gray-500 mt-8">
        © {new Date().getFullYear()} OILManager. Wszystkie prawa zastrzeżone.
      </p>
    </div>
  </footer>
);

// Główny komponent aplikacji
const App = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [descriptionData, setDescriptionData] = useState(null);
  const [offerData, setOfferData] = useState(null);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  useEffect(() => {
    // Pobieranie danych z opis.json
    fetch('/opis.json')
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(data => setDescriptionData(data))
      .catch(error => {
        console.error("Błąd ładowania opis.json:", error);
        setDescriptionData(placeholderDescription);
      });

    // Pobieranie danych z oferta.json
    fetch('/oferta.json')
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(data => setOfferData(data))
      .catch(error => {
        console.error("Błąd ładowania oferta.json:", error);
        setOfferData(placeholderOffer);
      });
  }, []);

  useEffect(() => {
    if (isModalOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isModalOpen]);

  return (
    <div className="bg-gray-50 font-sans text-gray-800 antialiased">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap');

        body {
          font-family: 'Inter', sans-serif;
        }

        .animate-fadeInUp {
          animation: fadeInUp 1s ease-out forwards;
          opacity: 0;
        }

        .animate-slideInFromTop {
          animation: slideInFromTop 1s ease-out forwards;
          opacity: 0;
        }

        .animate-slideInFromLeft {
          animation: slideInFromLeft 1s ease-out forwards;
          opacity: 0;
        }

        .animate-slideInFromRight {
          animation: slideInFromRight 1s ease-out forwards;
          opacity: 0;
        }

        .animate-zoomIn {
          animation: zoomIn 1s ease-out forwards;
          opacity: 0;
        }

        .delay-100 { animation-delay: 0.1s; }
        .delay-200 { animation-delay: 0.2s; }
        .delay-300 { animation-delay: 0.3s; }
        .delay-400 { animation-delay: 0.4s; }

        @keyframes fadeInUp {
          from {
            transform: translateY(20px);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }

        @keyframes slideInFromTop {
          from {
            transform: translateY(-20px);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }

        @keyframes slideInFromLeft {
          from {
            transform: translateX(-20px);
            opacity: 0;
          }
          to {
            transform: translateX(0);
            opacity: 1;
          }
        }

        @keyframes slideInFromRight {
          from {
            transform: translateX(20px);
            opacity: 0;
          }
          to {
            transform: translateX(0);
            opacity: 1;
          }
        }

        @keyframes zoomIn {
          from {
            transform: scale(0.9);
            opacity: 0;
          }
          to {
            transform: scale(1);
            opacity: 1;
          }
        }
      `}</style>

      <Header onMenuToggle={toggleMenu} />
      <MobileMenu isOpen={isMenuOpen} onClose={() => setIsMenuOpen(false)} />
      <main>
        <HeroSection />
        <DescriptionSection descriptionData={descriptionData} />
        <OfferSection offerData={offerData} onContactClick={openModal} />
      </main>
      <Footer onContactClick={openModal} />
      <ContactModal isOpen={isModalOpen} onClose={closeModal} />
    </div>
  );
};

export default App;

// Renderowanie aplikacji
const container = document.getElementById('root');
if (container) {
  const root = createRoot(container);
  root.render(<App />);
}